// PROJECTS
export const COMPOSE_TASK = 'COMPOSE_TASK';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_TASK = 'CREATE_TASK';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_TASK = 'DELETE_TASK';
export const FETCH_TASK_QUEUE = 'FETCH_TASK_QUEUE';
export const FETCH_TASK_QUEUE_REALTOR = 'FETCH_TASK_QUEUE_REALTOR';
export const NO_PROJECTS = 'NO_PROJECTS';
export const NO_TASKS = 'NO_TASKS';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const TASK_SELECTED = 'TASK_SELECTED';

//AUTH
export const USER_SIGNUP = 'USER_SIGNUP';
export const USER_SIGNUP_SUCCESSFUL = 'USER_SIGNUP_SUCCESSFUL';
export const USER_SIGNUP_REJECTED = 'USER_SIGNUP_REJECTED';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESSFUL = 'USER_LOGIN_SUCCESSFUL';
export const USER_LOGIN_REJECTED = 'USER_LOGIN_REJECTED';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESSFUL = 'USER_LOGOUT_SUCCESSFUL';
export const USER_LOGOUT_REJECTED = 'USER_LOGOUT_REJECTED';
export const USER_AUTH = 'USER_AUTH';
export const USER_AUTH_SUCCESSFUL = 'USER_AUTH_SUCCESSFUL';
export const USER_AUTH_REJECTED = 'USER_AUTH_REJECTED';
export const FIELD_CHANGED = 'FIELD_CHANGED';

//CALENDAR
export const FETCH_EVENTS = 'FETCH_EVENTS';

//TIMER
export const START_TIMER = 'START_TIMER';
export const PAUSE_TIMER = 'PAUSE_TIMER';
export const RESTART_TIMER = 'RESTART_TIMER';
export const STOP_TIMER = 'STOP_TIMER';
export const INCREMENT_TIMER = 'INCREMENT_TIMER';
export const SET_TIMER_TASK = 'SET_TIMER_TASK';
export const FETCH_TIMERS = 'FETCH_TIMERS';
export const NO_TIMERS = 'NO_TIMERS';
export const FETCH_TIMERS_REALTOR = 'FETCH_TIMERS_REALTOR';
export const NOTIFY_ADMIN_FINISHED = 'NOTIFY_ADMIN_FINISHED';

// COMMON
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./src/_actions/types.js